const PREFIX = 'PLANS_FILTER_MAP_';

export const SET_PLANS_FILTERS = `${PREFIX}SET_PLANS_FILTERS`;